import { useState } from "react";
import { createPortal } from "react-dom";
import { ArrowRight, Check, Crown, X } from "lucide-react";

const SUPPORT_URL = "https://t.me/episnyasupport?text="
  + encodeURIComponent("Доброго дня, хочу замовити професійну пісню під мою подію");

const PERKS = [
  "Напишемо кілька текстів вручну",
  "Кілька варіантів звучання — різні жанри та голоси",
  "Професійна обробка звучання",
];

export function PremiumModal({ open, onClose }) {
  if (!open) return null;
  return createPortal(
    <div className="pm-wrap" role="dialog" aria-modal="true" data-testid="premium-modal">
      <div className="pm-back" onClick={onClose} />
      <div className="pm-modal">
        <button type="button" className="pm-close" onClick={onClose} aria-label="Закрити">
          <X size={18} />
        </button>
        <div className="pm-head">
          <div className="pm-crown"><Crown size={22} strokeWidth={2.2} /></div>
          <div>
            <div className="pm-title">Premium</div>
            <div className="pm-sub">ручний продакшн</div>
          </div>
          <div className="pm-price">1999 ₴</div>
        </div>
        <p className="pm-text">
          Якщо у вас дуже важлива подія, потребує професійного підходу, наша
          команда звукорежисерів та композиторів напишуть кілька варіантів
          тексту, та декілька варіантів звучання в різних жанрах та голосах —
          щоб ваша подія пройшла ідеально.
        </p>
        <div className="pm-perks">
          {PERKS.map((p) => (
            <div className="pm-perk" key={p}>
              <span className="pm-perk-ico"><Check size={13} strokeWidth={3} /></span>
              {p}
            </div>
          ))}
        </div>
        <a className="pm-cta" href={SUPPORT_URL} target="_blank" rel="noreferrer"
          data-testid="premium-write">
          Написати нам <ArrowRight size={16} />
        </a>
        <div className="pm-note">Відповідаємо у Telegram · @episnyasupport</div>
      </div>
    </div>,
    document.body,
  );
}

export default function PremiumCard({ className = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" data-testid="premium-card"
        onClick={() => setOpen(true)}
        className={`pkg-card premium ${className}`.trim()}>
        <span className="pkg-badge">Vip</span>
        <span className="pkg-price">1999 ₴</span>
        <span className="pkg-name">Premium</span>
        <span className="pkg-meta">
          команда професійних композиторів та звукорежисерів зробить для вас власноруч.
        </span>
        <span className="pkg-cta">Детальніше <ArrowRight size={14} /></span>
        <span className="pkg-note"><i />ручна робота команди</span>
      </button>
      <PremiumModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
